import { ROLES } from "./roles";

const COMMON_PATHS = new Set([
  "/",
  "/optionsscreen",
  "/studentdashboard",
  "/resourcestab",
]);

const EDUCATOR_PATHS = new Set([
  ...COMMON_PATHS,
  "/dashboard",
  "/studentsupports",
]);

const PAUSED_STUDENT_PATHS = COMMON_PATHS;

/**
 * Returns the correct sidebar path Set for the current user.
 *
 * @param {string}  role
 * @param {boolean} isPaused
 * @returns {Set<string>}
 */
export function getSidebarPaths(role, isPaused = false) {
  if (role === ROLES.STUDENT) {
    return PAUSED_STUDENT_PATHS;
  }
  return EDUCATOR_PATHS;
}

export const SIDEBAR_PATHS = EDUCATOR_PATHS;
